<template>
  <iframe
    :class="bem('iframe')"
    width="100%"
    height="100%"
    :src="src"
    frameborder="0"
    allow="autoplay; encrypted-media"
    allowfullscreen="true"
  />
</template>
<script setup lang="ts">
interface ExternalVideoEmbed {
  video: any
}

const props = defineProps<ExternalVideoEmbed>()

const src = computed(() => {
  if (props.video?.provider === 'youtube')
    return `https://www.youtube.com/embed/${props.video?.providerUid}?rel=0&enablejsapi=1&origin=https://www.sungod.co`

  if (props.video?.provider === 'vimeo')
    return `https://player.vimeo.com/video/${props.video?.providerUid}`

  throw new Error(`Unknown video provider: ${props.video?.provider}`)
})
const bem = useBEM('MediaOverlay')
</script>